// fetchFallback disabled for emergency rollback — no-op implementation
(function () {
  try {
    if (typeof window !== 'undefined') {
      window.__FETCH_FALLBACK_DISABLED = true;
    }
  } catch (e) { void e; }
})();
